// extracted by mini-css-extract-plugin
export var copy = "permacopy-styles-module--copy--13271";
export var linkIcon = "permacopy-styles-module--link-icon--41371";
export var permaBtn = "permacopy-styles-module--permaBtn--4ae0c";
export var slideDownAndFade = "permacopy-styles-module--slideDownAndFade--225db";
export var slideLeftAndFade = "permacopy-styles-module--slideLeftAndFade--28e99";
export var slideRightAndFade = "permacopy-styles-module--slideRightAndFade--d437d";
export var slideUpAndFade = "permacopy-styles-module--slideUpAndFade--63963";
export var toolTipArrow = "permacopy-styles-module--tool-tip-arrow--5bfa4";
export var toolTipContent = "permacopy-styles-module--tool-tip-content--c4cf8";